import { render } from "./EditPasswordView.vue?vue&type=template&id=2feb5ca0&scoped=true"
import script from "./EditPasswordView.vue?vue&type=script&lang=js"
export * from "./EditPasswordView.vue?vue&type=script&lang=js"

import "./EditPasswordView.vue?vue&type=style&index=0&id=2feb5ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feb5ca0"]])

export default __exports__